import { Box, Card, CardContent, CardHeader, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
import ButtonWithLoading from "../../../../../components/ButtonWithLoading";
import { getTranslation } from "../../../../../heplers/translationHelper";
import { format } from "../../../../../heplers/format";
import SplitAmountMapper from "../../splitAmountMapper";
import { useEffect, useState } from "react";
import ManualSplitAmountMapper from "./manualSplitAmountMapper";

export const IndexationDetails = ({ oldRent, newRent, fundsArray, percentage, increaseAmount, onNewRentChange }) => {
	const rentAmountError = false;
	const [fundToCategoryArray, setFundToCategoryArray] = useState([]);
	// const [appartmentRent, setAppartmentRent] = useState(1000);
	const [update, setUpdate] = useState(true);
	useEffect(() => {
		if (fundsArray) {
			var tempArray = []
			fundsArray.filter(x=>x.isIndexed).forEach(fund => {
				tempArray.push({ ...fund, newAmount: fund.amount + (fund.amount / oldRent * increaseAmount) })
			});
			setFundToCategoryArray(tempArray);

		}
	}, [fundsArray, percentage, increaseAmount])
	const handleOnAdd = () => {
		const arr = fundToCategoryArray;
		setFundToCategoryArray([
			...arr,
			{ isIndexed: false, type: 0, amount: 0, description: "" },
		]);
	};
	return <Card>
		<CardHeader title="Details">

		</CardHeader>
		<CardContent>

			<Box
				style={{
					display: "flex",
					justifyContent: "space-between",
					marginBottom: "10px",
				}}
			>
				<Grid container spacing={3}>

					<Grid
						item
						xs={12}
						sm={6}
						md={6}
						lg={6}
						xl={6}
						style={{ marginTop: "20px" }}
					>
						<TextField
							disabled={true}
							id="oldRent"
							fullWidth
							//type="number"
							label={getTranslation(
								"Total Old Rent(Indexed)",
								"Total Old Rent(Indexed)",
								"Total Old Rent(Indexed)"
							)}
							required
							size="small"
							variant="outlined"
							name={"oldRent"}
							value={format("number", oldRent)}
							InputLabelProps={{
								shrink: true,
							}}
							InputProps={{ inputProps: { min: 0 } }}
						/>
					</Grid>
					<Grid
						item
						xs={12}
						sm={6}
						md={6}
						lg={6}
						xl={6}
						style={{ marginTop: "20px" }}
					>
						<TextField
							disabled={true}
							id="newRent"
							fullWidth
							//type="number"
							label={getTranslation(
								"Total New Rent(Indexed)",
								"Total New Rent(Indexed)",
								"Total New Rent(Indexed)"
							)}
							required
							size="small"
							variant="outlined"
							name={"newRent"}
							value={format("number", newRent)}
							InputLabelProps={{
								shrink: true,
							}}
							InputProps={{ inputProps: { min: 0 } }}
						/>
					</Grid>

					{/* <Grid
										item
											xs={12}
											sm={6}
											md={4}
											lg={6}
											style={{ marginTop: "20px" }}
										>
											<TextField
												id="warranty"
												fullWidth
												label={getTranslation("Warranty", "Warranty", "Warranty")}
												//type="number"
												size="small"
												disabled={true}
												variant="outlined"
												name={"warranty"}
												value={format("number", 500)}
												InputLabelProps={{
													shrink: true,
												}}
												InputProps={{ inputProps: { min: 0 } }}
											/>
										</Grid> */}
				</Grid>
			</Box>

			<ManualSplitAmountMapper
				update={update}
				title="update"
				array={fundToCategoryArray}
				setArray={setFundToCategoryArray}
				setWarranty={() => { }}
				appartmentRent={newRent}
				setAppartmentRent={onNewRentChange}
				enableError={true}
				disableError={true}
				initialRent={oldRent}
			/>

		
			{rentAmountError && (
				<p
					style={{
						color: "red",
						textAlign: "center",
						paddingTop: "15px",
					}}
				>
					{getTranslation(
						"Amount of Rent Cant be less then the initail rent",
						"Amount of Rent Cant be less then the initail rent",
						"Amount of Rent Cant be less then the initail rent"
					)}
				</p>
			)}



		</CardContent>
	</Card>
}